// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Autocomplete from "../shared/autocomplete.bs.js";
import * as ReactDebounce from "rescript-debounce-react/src/ReactDebounce.bs.js";

function TargetAutocomplete(Props) {
  var onSubmit = Props.onSubmit;
  var match = React.useState(function () {
        return false;
      });
  var setDisplay = match[1];
  var display = match[0];
  var match$1 = React.useState(function () {
        return "";
      });
  var setSearch = match$1[1];
  var search = match$1[0];
  var match$2 = React.useState(function () {
        return [];
      });
  var setOptions = match$2[1];
  var options = match$2[0];
  var updateOptions = function (pattern) {
    Autocomplete.$$fetch(pattern).then(function (options) {
          return Curry._1(setOptions, (function (param) {
                        return options;
                      }));
        });
    
  };
  var updateOptionsDebounced = ReactDebounce.useDebounced(275, updateOptions);
  React.useEffect((function () {
          if (display) {
            Curry._1(updateOptionsDebounced, search);
            console.log(options);
          }
          
        }), [search]);
  return React.createElement("form", {
              className: "form-inline my-2 my-lg-0 pos-rel",
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(onSubmit, search);
                  Curry._1(setDisplay, (function (param) {
                          return false;
                        }));
                  return Curry._1(setSearch, (function (param) {
                                return "";
                              }));
                })
            }, React.createElement("input", {
                  className: "form-control mr-sm-2 form-control",
                  placeholder: "Группа/преподаватель",
                  value: search,
                  onChange: (function ($$event) {
                      var a = $$event.target.value;
                      Curry._1(setSearch, (function (param) {
                              return a;
                            }));
                      return Curry._1(setDisplay, (function (param) {
                                    return true;
                                  }));
                    })
                }), React.createElement("button", {
                  className: "btn btn-primary",
                  type: "submit"
                }, "Открыть"), display ? React.createElement("ul", {
                    className: "autoContainer list-group"
                  }, Belt_Array.map(options, (function (option) {
                          return React.createElement("li", {
                                      key: option,
                                      className: "list-group-item",
                                      onClick: (function (param) {
                                          return Curry._1(setSearch, (function (param) {
                                                        return option;
                                                      }));
                                        })
                                    }, React.createElement("span", undefined, option));
                        }))) : React.createElement(React.Fragment, undefined));
}

var make = TargetAutocomplete;

export {
  make ,
  
}
/* react Not a pure module */
